<template>
    <cmpRec v-bind:name="name"
                   v-bind:pkColumn="pkColumn"
                   v-bind:fields="fields"
                   v-bind:parent="parent"
                   v-bind:header="header"></cmpRec>
</template>

<script>
    import i18n from '@/i18n'
    import cmpRec from "@/components/common/cmpRec"

    export default {
        components: {
            cmpRec
        },
        computed: {
            fields() {
                return [
                    { "key": "CourseName", "label": i18n.t('component.GoldenSampleFeature.CourseName.label') },
                    { "key": "FeatureFieldName", "label": i18n.t('component.GoldenSampleFeature.FeatureFieldName.label') },
                    { "key": "FeatureFieldValue", "label": i18n.t('component.GoldenSampleFeature.FeatureFieldValue.label') },
                    { "key": "FeatureFieldValueNormal", "label": i18n.t('component.GoldenSampleFeature.FeatureFieldValueNormal.label') },
                    { "key": "FeatureFieldValueAbnormal", "label": i18n.t('component.GoldenSampleFeature.FeatureFieldValueAbnormal.label') },
                    { "key": "FeatureFieldSorting", "label": i18n.t('component.GoldenSampleFeature.FeatureFieldSorting.label') },
                ]
            },
            header() {
                return i18n.t('component.GoldenSampleFeature.recHeader')
            }
        },
        data() {

            return {
                name: "GoldenSampleFeature",
                pkColumn: "GoldenSampleFeatureId",
                parent: {}
            };
        }
    }
</script>